import * as angular from 'angular';
export const Component = (options: angular.IComponentOptions): (arg) => any => {
    return (controller: () => any) => {
        return angular.extend(options, { controller });
    };
};
